/* Extraido de snippets/norte-cart-upsell.liquid el 2026-08-24.
   Vivia dentro de {% if cart.item_count > 0 %}, asi que con el carrito
   vacio no existia. La seccion norte-2x1-regalo usa las mismas tarjetas
   en una landing, donde el carrito SI suele estar vacio: por eso ahora se
   carga siempre desde theme.liquid. */
(function () {
    // El "+" hacia un POST normal: recargaba la pagina y cerraba el drawer.
    // Aqui se agrega por AJAX. Ojo con el contexto:
    //   - En /cart NO se abre el mini-carrito (seria absurdo estando ya en el
    //     carrito): se refrescan las secciones de la propia pagina.
    //   - En cualquier otra pagina si se abre el drawer.
    if (window.NorteUpsellAddInit) return;
    window.NorteUpsellAddInit = true;

    function enPaginaCarrito() {
      // <cart-items> solo existe en la plantilla /cart; el drawer usa
      // <cart-drawer-items>, asi que no hay confusion posible.
      return !!document.querySelector('#MainContent cart-items');
    }

    // LIMITE DURO: la API de secciones de Shopify acepta 5 como maximo. Si se
    // piden 6 devuelve `sections: {}` vacio, sin error ni aviso, y no se
    // repinta nada. Por eso aqui se eligen SOLO las que dependen del carrito
    // (se deja fuera, por ejemplo, la franja de sellos de confianza).
    var MAX_SECCIONES = 5;

    function seccionesDeLaPagina() {
      var ids = [];
      function agregarSeccionDe(selector) {
        var nodo = document.querySelector(selector);
        var seccion = nodo && nodo.closest('#MainContent > .shopify-section');
        if (!seccion) return;
        var id = seccion.id.replace('shopify-section-', '');
        if (id && ids.indexOf(id) === -1) ids.push(id);
      }

      agregarSeccionDe('#MainContent cart-items');       // lista de articulos
      agregarSeccionDe('#MainContent #main-cart-footer'); // totales y pagar
      agregarSeccionDe('#MainContent .norte-upsell');     // carrusel del 2x1

      // Estos dos no viven en #MainContent pero tambien hay que refrescarlos.
      ids.push('cart-icon-bubble', 'cart-drawer');

      return ids.filter(Boolean).slice(0, MAX_SECCIONES).join(',');
    }

    function pintarSecciones(state) {
      var secciones = state.sections || {};

      Object.keys(secciones).forEach(function (id) {
        var doc = new DOMParser().parseFromString(secciones[id], 'text/html');

        // La burbuja del carrito NO se renderiza como seccion propia: vive
        // dentro de .header__icons, asi que se reemplaza por su id directo.
        if (id === 'cart-icon-bubble') {
          // La respuesta trae el CONTENIDO del enlace (icono + contador), no un
          // elemento con id="cart-icon-bubble": hay que tomar el interior del
          // wrapper de la seccion y volcarlo en el enlace vivo.
          var burbuja = document.getElementById('cart-icon-bubble');
          var envoltura = doc.getElementById('shopify-section-cart-icon-bubble');
          if (burbuja && envoltura) burbuja.innerHTML = envoltura.innerHTML;
          return;
        }

        // El drawer se sincroniza a mano: su renderContents() abre el panel al
        // final, y aqui justamente no queremos que se abra.
        if (id === 'cart-drawer') {
          var drawerEl = document.querySelector('cart-drawer');
          var interiorNuevo = doc.querySelector('.drawer__inner');
          var interiorActual = drawerEl && drawerEl.querySelector('.drawer__inner');
          if (interiorActual && interiorNuevo) {
            interiorActual.innerHTML = interiorNuevo.innerHTML;
            var vacio = doc.querySelector('cart-drawer');
            if (vacio) drawerEl.classList.toggle('is-empty', vacio.classList.contains('is-empty'));
          }
          return;
        }

        var destino = document.getElementById('shopify-section-' + id);
        var fuente = doc.getElementById('shopify-section-' + id);
        if (destino && fuente) destino.innerHTML = fuente.innerHTML;
      });
    }

    function confirmar(button) {
      if (!button) return;
      button.classList.add('norte-upsell__add--ok');
      button.setAttribute('aria-label', 'Agregado al carrito');
    }

    document.addEventListener('submit', function (event) {
      var form = event.target.closest('.norte-upsell__form');
      if (!form) return;
      event.preventDefault();

      var button = form.querySelector('.norte-upsell__add');
      if (button) { if (button.disabled) return; button.disabled = true; }

      var esCarrito = enPaginaCarrito();
      var drawer = esCarrito ? null : document.querySelector('cart-drawer');

      var body = {
        items: [{ id: Number(form.querySelector('input[name="id"]').value), quantity: 1 }]
      };
      if (esCarrito) {
        body.sections = seccionesDeLaPagina();
        // OJO: nada de `sections_url`. Con ese parametro Shopify devuelve
        // `sections: {}` vacio y no se repinta nada. Sin el usa el contexto de
        // la pagina desde la que se pide, que es justo lo que queremos.
      } else if (drawer) {
        body.sections = 'cart-drawer,cart-icon-bubble';
      }

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      })
        .then(function (response) { return response.json(); })
        .then(function (state) {
          if (state.status) throw new Error(state.description || 'cart/add fallo');

          if (esCarrito) {
            // Se ve la palomita y despues se repinta: asi el cliente alcanza a
            // registrar que si se agrego antes de que el carrusel cambie.
            confirmar(button);
            setTimeout(function () { pintarSecciones(state); }, 700);
            return;
          }

          if (drawer && state.sections) {
            drawer.renderContents(state);
            if (typeof drawer.open === 'function') drawer.open();
          } else {
            window.location.href = window.Shopify.routes.root + 'cart';
          }
        })
        .catch(function () {
          // Si algo falla, se manda al carrito para que el cliente no quede colgado.
          window.location.href = window.Shopify.routes.root + 'cart';
        })
        .finally(function () {
          // En /cart el boton desaparece al repintar; el reset es por si acaso.
          if (button && !esCarrito) button.disabled = false;
        });
    });
  })();
